import { createAction } from '@reduxjs/toolkit';

export const fetchAndProcessMerchantOrders = createAction('FETCH_AND_PROCESS_MERCHANT_ORDERS');
